import $ from 'jquery'
export default {
  created () {
  },
  // 离开当前路由
  beforeRouteLeave (to, from, next) {
    // 隐藏当前组件的模态框
    // 需要影藏的模态框id (#modal-container-newLogin)
    // $('#modal-container-newLogin').modal('hide')
    $('.modal-backdrop').remove()
    // 离开当前路由
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/mixins/index.js